import React from "react"
import { useProductCard } from "../../hooks/useProductCard"
import { productCardCategoryName } from "./ProductCard.css"

export const ProductCardBrandName: React.FC = () => {
  const { productCardData } = useProductCard()
  if (!productCardData.brandName) return null
  return <p className={productCardCategoryName}>{productCardData.brandName}</p>
}
